import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiStoreUsersList, apiStoreUsersView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/storeUsers/getData', async datas => {
    const { data } = await apiStoreUsersList(datas)
    return data
})

export const getView = createAsyncThunk('admin/storeUsers/getView', async id => {
    if (!id) return viewData
    const { data } = await apiStoreUsersView(id)
    data.image = ''
    return data
})

const viewData = {
    store_id: '',
    role_id: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    password: '',
    password_confirmation: '',
    image: '',
    address: '',
    country_id: '',
    state_id: '',
    city_id: '',
    pincode: '',
    permissions: [],
}

export const storeUsersSlice = createSlice({
    name: 'admin/storeUsers',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = storeUsersSlice.actions

export default storeUsersSlice.reducer
